import { render, staticRenderFns } from "./OverviewCards.vue?vue&type=template&id=548fb4fd&scoped=true&"
import script from "./OverviewCards.vue?vue&type=script&lang=js&"
export * from "./OverviewCards.vue?vue&type=script&lang=js&"
import style0 from "./OverviewCards.vue?vue&type=style&index=0&id=548fb4fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548fb4fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCol,VIcon,VRow,VSkeletonLoader})
